import { Paper, Typography } from '@mui/material';
interface QueryFilterNLSGroupHeaderProps {
  header: string | null;
}

export const QueryFilterNLSGroupHeader = ({
  header,
}: QueryFilterNLSGroupHeaderProps) => {
  if (!header) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ px: 2, py: 1, mt: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {header}
      </Typography>
    </Paper>
  );
};
